import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const ClinicDetails = ({ data }) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th colSpan="2">
          <div className="pagination-container">
            <h5>Clinic Details</h5>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td />
        <td>
          <span className="subheader">Parent Clinic:</span>
          <span>{data.parentClinic ? data.parentClinic.legalname : ''}</span>
          <span className="subheader">NPI:</span>
          <span>{data.npiNumber}</span>
          <span className="subheader">State ID:</span>
          <span className="text-transform-none">{data.stateIdNumber}</span>
          <span className="subheader">Tax id EIN:</span>
          <span>{data.taxIdNumber}</span>
          <span className="subheader">Medicaid Tpi:</span>
          <span>{data.medicalIdTpiNumber}</span>
          <span className="subheader">Medicare Number:</span>
          <span>{data.medicareNumber}</span>
          <span className="subheader">OTS:</span>
          <span>{data.ots === true ? 'True' : 'False'}</span>
          <span className="subheader">OTS Start Date:</span>
          <span>{data.otsStartDate}</span>
          <span className="subheader">Auto-generated Claim Drop:</span>
          <span>{data.autoGeneratedClaimDrop === true ? 'True' : 'False'}</span>
          <span className="subheader">Office Hours:</span>
          <span>{data.officeHours}</span>
          <span className="subheader">FIN ID:</span>
          <span>{data.finId}</span>
        </td>
      </tr>
    </tbody>
  </Table>
);

ClinicDetails.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ClinicDetails;
